import { useContext } from 'react';

import { ToggleContext } from '../context';

/**
 * A React hook helper to retrieve data and access functions
 * from the ToggleContext
 */
export const useToggleContext = () => useContext(ToggleContext);
